import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgInfoCircle = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18 21.5V19a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14H16v-8a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14h-5a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36V13a.49.49 0 0 0 .14.36.49.49 0 0 0 .36.14H12v5h-1.5a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v2.5a.49.49 0 0 0 .14.36.49.49 0 0 0 .36.14h7a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36zm-2-14V5a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14h-3a.487.487 0 0 0-.36.14A.487.487 0 0 0 12 5v2.5a.49.49 0 0 0 .14.36.49.49 0 0 0 .36.14h3a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36zM26 14c0 2.177-.537 4.185-1.61 6.023a11.945 11.945 0 0 1-4.367 4.368C18.185 25.464 16.177 26 14 26c-2.177 0-4.185-.537-6.023-1.61a11.945 11.945 0 0 1-4.368-4.367C2.536 18.185 2 16.177 2 14c0-2.177.536-4.185 1.61-6.023a11.946 11.946 0 0 1 4.367-4.368C9.815 2.536 11.823 2 14 2c2.177 0 4.185.536 6.023 1.61a11.945 11.945 0 0 1 4.368 4.367C25.464 9.815 26 11.823 26 14z" />
  </svg>
);
export default SvgInfoCircle;
